import { configureStore } from '@reduxjs/toolkit';
import gameReducer from './gameSlice';
import authReducer from './authSlice';
import walletReducer from './walletSlice';
import { api } from '../services/api';

export const store = configureStore({
  reducer: {
    game: gameReducer,
    auth: authReducer,
    wallet: walletReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
